<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">


    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 p-4 mb-5" style="transform: translateX(-19vw)">
      <div class=" p-3 card card-body card-panel-box border-0">
      <h3 style="font-size: 1.4vw !important;" class="text-end mb-5"> شناسایی نیازهای ذی نفعان </h3>
      <div class="row w-100 justify-content-between flex-nowrap">
        <div class="card col-6  d-flex flex-column align-items-center justify-content-center">
          <h5 style="font-size: 1.4vw !important;" class="mt-3">بر اساس خبرگی </h5>
          <router-link class="btn btn-submit-1 btn-info w-75 m-4" to="/beneficiary/Expertise">تکمیل اطلاعات / بروزرسانی</router-link>

        </div>
        <div class="card col-6 d-flex flex-column align-items-center justify-content-center mx-2">
          <h5 style="font-size: 1.4vw !important;" class="mt-3">مبتنی بر فرآیند</h5>
          <router-link class="btn btn-submit-1 btn-info w-75 m-4" to="/beneficiary/index">تکمیل اطلاعات / بروزرسانی</router-link>

        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar";
import Splash from "@/components/Splash/Splash";
export default {
  name: "beneficiary_id",
  components: {Splash, Sidebar}
}
</script>

<style scoped>
.row{
  padding: .5vw;
}
a{
  font-size: 1vw !important;
}
</style>